var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVeg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_2446)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48874 14C1.07807 14 0.727245 13.8546 0.436265 13.5637C0.145422 13.2728 0 12.9219 0 12.5113V1.48874C0 1.07807 0.145422 0.727245 0.436265 0.436265C0.727245 0.145422 1.07807 0 1.48874 0H12.5113C12.9219 0 13.2728 0.145422 13.5637 0.436265C13.8546 0.727245 14 1.07807 14 1.48874V12.5113C14 12.9219 13.8546 13.2728 13.5637 13.5637C13.2728 13.8546 12.9219 14 12.5113 14H1.48874ZM1.48874 12.7647H12.5113C12.5852 12.7647 12.646 12.741 12.6935 12.6935C12.741 12.646 12.7647 12.5852 12.7647 12.5113V1.48874C12.7647 1.41475 12.741 1.35402 12.6935 1.30653C12.646 1.25904 12.5852 1.23529 12.5113 1.23529H1.48874C1.41475 1.23529 1.35402 1.25904 1.30653 1.30653C1.25904 1.35402 1.23529 1.41475 1.23529 1.48874V12.5113C1.23529 12.5852 1.25904 12.646 1.30653 12.6935C1.35402 12.741 1.41475 12.7647 1.48874 12.7647ZM7 9.98529C6.17331 9.98529 5.46913 9.69438 4.88744 9.11256C4.30562 8.53087 4.01471 7.82669 4.01471 7C4.01471 6.17331 4.30562 5.46913 4.88744 4.88744C5.46913 4.30562 6.17331 4.01471 7 4.01471C7.82669 4.01471 8.53087 4.30562 9.11256 4.88744C9.69438 5.46913 9.98529 6.17331 9.98529 7C9.98529 7.82669 9.69438 8.53087 9.11256 9.11256C8.53087 9.69438 7.82669 9.98529 7 9.98529Z",
    fill: "#67AF7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_2446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeg);
export default __webpack_public_path__ + "static/media/icon-veg.350bb548b6ede6494cd11d5c80cd9ee9.svg";
export { ForwardRef as ReactComponent };